var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166.91 176.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #44b9a0;\r\n        font-size: 14.28px;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        font-family: Magistral-Bold, Magistral;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-family: DaddyRewind, 'Daddy Rewind';\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #0b2420;\r\n        font-size: 39.53px;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 93.84,
    y1: -30.43,
    x2: 93.84,
    y2: 132.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98cb60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22aabe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 71.92,
    y1: -30.43,
    x2: 71.92,
    y2: 132.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 97.65,
    y1: -30.43,
    x2: 97.65,
    y2: 132.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 104.97,
    y1: -30.43,
    x2: 104.97,
    y2: 132.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 57.58,
    y1: -30.43,
    x2: 57.58,
    y2: 132.72,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.94,33.52c-5.99-5.99-13.96-9.29-22.43-9.29s-16.44,3.3-22.43,9.29l-38.64,38.64,2.03,2.03c4.99,4.99,11.8,4.14,18.22-2.27l16.49-16.49-5.31-4.62,12.25-12.25c9.59-9.59,25.2-9.59,34.79,0,9.59,9.59,9.59,25.2,0,34.79l-44.97,44.97,5.04,5.04,44.97-44.97c5.99-5.99,9.29-13.96,9.29-22.43,0-8.47-3.3-16.44-9.29-22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,69.75c-3.28,3.28-6.66,5.02-9.76,5.02-2.15,0-4.13-.84-5.89-2.49h0s.87.88.87.88c1.82,1.82,3.89,2.75,6.15,2.75,3.1,0,6.48-1.73,9.76-5.02l15.25-15.25-1.21-1.06-15.17,15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.29,18.7c3.42,3.42,8.27,4.63,12.97,3.72.91-4.7-.3-9.55-3.72-12.97-3.42-3.42-8.27-4.63-12.97-3.72-.91,4.7.3,9.55,3.72,12.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.76,17.51c-4.51,4.51-10.92,6.11-17.13,4.91-1.2-6.21.4-12.61,4.91-17.13C96.05.78,102.46-.82,108.67.39c1.2,6.21-.4,12.61-4.91,17.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.37,63.85l-10.98-13.23c-.75-.75-1.79-1.13-2.84-1.03l-11.6,1.06-7.03-7.03-5.04,5.04,7.03,7.03-1.06,11.6c-.1,1.05.28,2.09,1.03,2.84l13.23,10.98c.97.81,2.39.93,3.42.19,1.44-1.02,1.56-3.03.37-4.23l-8.21-8.21c-.7-.7-.7-1.82,0-2.52h0c.68-.68,1.78-.7,2.48-.04l8.55,8.02c.93.87,2.34,1.05,3.4.35,1.47-.97,1.65-2.95.51-4.17l-8.07-8.61c-.66-.7-.64-1.8.04-2.48.7-.7,1.82-.7,2.52,0l8.21,8.21c1.19,1.19,3.2,1.07,4.23-.37.73-1.03.61-2.45-.19-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M40.99,73.35c-4.65-4.65-7.21-10.82-7.21-17.4s2.56-12.75,7.21-17.4c4.65-4.65,10.82-7.21,17.4-7.21s12.75,2.56,17.4,7.21l7.67,7.67,5.04-5.04-7.67-7.67c-12.37-12.37-32.49-12.37-44.86,0-12.37,12.37-12.37,32.49,0,44.86l44.97,44.97c.7.7,1.61,1.04,2.52,1.04s1.82-.35,2.52-1.04c1.39-1.39,1.39-3.65,0-5.04l-44.97-44.97Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(0 155.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DietCare")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(13.86 171.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "Eat Smart"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 57.98,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 62.5,
    y: 0,
    xmlSpace: "preserve"
  }, " Live Healthy"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietcare);
export default __webpack_public_path__ + "static/media/dietcare.72ae8acfb306d55bfb6e179ee6a420b9.svg";
export { ForwardRef as ReactComponent };